import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import {
  STRAVA_DEFAULT_PAGE_SIZE,
  StravaActivitiesPage,
} from "src/pages/StravaActivitiesPage";
import {
  stravaActivitiesQueryOptions,
  stravaStatusQueryOptions,
} from "src/queries/integrations";

const routeSearchSchema = z.object({
  p: z.number().optional(),
  ps: z.number().optional(),
});

export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/settings/integrations/strava/activities",
)({
  component: StravaActivitiesPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  loaderDeps: ({ search }) => {
    return search;
  },
  async loader({ context, deps, params }) {
    return await loaderHandler(async () => {
      const stravaStatus = await context.queryClient.query({
        ...stravaStatusQueryOptions(),
        staleTime: "static",
      });

      if (!stravaStatus.connected) {
        throw redirect({
          to: "/orgs/$slug/settings/profile",
          params: { slug: params.slug },
        });
      }

      const pageIndex = deps.p ?? 0;
      const page = pageIndex + 1;
      const limit = deps.ps ?? STRAVA_DEFAULT_PAGE_SIZE;

      await context.queryClient.query({
        ...stravaActivitiesQueryOptions({ page, limit }),
        staleTime: "static",
      });
      return { data: null };
    });
  },
});
